import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
const backendUrl = process.env.REACT_APP_BACKEND_URL;

const initialState = {
  isLoading: false,
  error: null,
  venues: [],
  venue: null,
  warehouseStatus: {
    hasAssociatedWarehouses: false,
    hasPurchaseOrders: false,
    hasPurchaseOrderInvoices:false, 
    hasTransactions: false
  },
};

const slice = createSlice({
  name: 'venue',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET CATEGORIES
    getVenuesSuccess(state, action) {
      state.isLoading = false;
      state.venues = action.payload;
    },

    // GET CATEGORY
    getVenueSuccess(state, action) {
      state.isLoading = false;
      state.venue = action.payload;
    },
    setWarehouseStatus(state, action) {      
      state.warehouseStatus = {
        hasAssociatedWarehouses: action.payload.hasAssociatedWarehouses,
        hasPurchaseOrders: action.payload.hasPurchaseOrders,
        hasPurchaseOrderInvoices:action.payload.hasPurchaseOrderInvoices,
        hasTransactions: action.payload.hasTransactions
      };
    },
  },

});

// Reducer
export default slice.reducer;

// Actions
// export const {
// } = slice.actions;

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export function getVenue(venueId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${backendUrl}/venues/${venueId}`);
      dispatch(slice.actions.getVenueSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateVenueOnlineStatus(venueId, isOnline, tempPhotoURL) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    const payload = {
      isOnline,
      tempPhotoURL,
    };
    try {
      const response = await axios.patch(`${backendUrl}/venues/${venueId}`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch(slice.actions.getVenueSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function statusWarehousePurchaseOrder(venueId, franchiseId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${backendUrl}/venues/status/warehouse-purchaseOrder`, {
        params: {
          venueId,
          franchiseId,
        },
      });

      dispatch(slice.actions.setWarehouseStatus(response.data));
      // dispatch(slice.actions.getVenueSuccess(response.data));
    } catch (error) {
      console.error('Error fetching purchase order status:', error);
    }
  };
}
